// BM-7639 — Pure selectors / helpers shared by the column-calculation host and pill renderer.

export const sumColumnAcrossRows = (rows, columnId) => {
  if (!Array.isArray(rows) || !columnId) return 0;
  let total = 0;
  for (const row of rows) {
    const children = Array.isArray(row?.expandData) ? row.expandData : [];
    for (const child of children) {
      const raw = child?.columns?.[columnId]?.value;
      const num = typeof raw === 'number' ? raw : parseFloat(raw);
      if (Number.isFinite(num)) total += num;
    }
  }
  return total;
};

export const maxTickedScopes = (columnTotals) => {
  if (!columnTotals) return 0;
  return Object.values(columnTotals).reduce((max, entry) => {
    const scopesCount = Array.isArray(entry?.scopes) ? entry.scopes.length : 0;
    return scopesCount > max ? scopesCount : max;
  }, 0);
};
